__webpack_require__.p = "/MIMBCD-UI/prototype-context-aware/";